module.exports = __webpack_public_path__ + "static/media/grav.a3b214b9.svg";